import { SyntheticEvent } from "react";
import { ICar } from "src/api/car";
import { CarByNewApi } from "../api/car-by-new-api.ts";
import { Status } from "../enums/status.enum.ts";
import { StatusId } from "../types/status-id.type.ts";

export const editCarNumber = (number: string) => {
  return number.replace(/\d+/g, str => ` ${str} `);
};

export const splitCarNumber = (carNumber: string, splitValue: string) => {
  return editCarNumber(carNumber).split(splitValue);
};

export const filtereData = (houseData: ICar[] | null, searchValue: string) => {
  if (houseData) {
    return houseData.filter(item => {
      return item.carNumber.replace(/\D/g, "").startsWith(searchValue);
    });
  }
};

export const stopPropagationHandler = (e: SyntheticEvent) => {
  e.stopPropagation();
};

export const preventDefaultHandler = (e: SyntheticEvent) => {
  e.preventDefault();
};

export const onMouseDownLinkHandler = (
  e: SyntheticEvent<HTMLAnchorElement>,
) => {
  e.currentTarget.click();
};

export const mapCarByNewApiToCar = (carByNewApi: CarByNewApi): ICar => {
  return {
    carNumber: carByNewApi.car_number ?? "-",
    carsQuantity:
      carByNewApi.cars_quantity !== undefined
        ? Number(carByNewApi.cars_quantity)
        : null,
    gateId: carByNewApi.gate_id ? Number(carByNewApi.gate_id) : null,
    gateName: carByNewApi.gate_num ?? null,
    queueId: Number(carByNewApi.queue_id),
    queueNumber: carByNewApi.queue_number ?? NaN,
    statusId: carByNewApi.status,
    statusName: carByNewApi.status_name,
    warehouseId: carByNewApi.office_id ?? NaN,
    warehouseName: carByNewApi.office_name ?? "-",
  };
};

export const statusToStatusIdMap: Record<Status, StatusId> = {
  [Status.SUPPLIER_QUEUE_STATUS_WAITING]: 0,
  [Status.SUPPLIER_QUEUE_STATUS_AT_GATE]: 1,
  [Status.SUPPLIER_QUEUE_STATUS_UNLOADING_FINISHED]: 2,
  [Status.SUPPLIER_QUEUE_STATUS_DEPARTED]: 3,
};

export const statusIdToStatusMap: Record<StatusId, Status> = {
  0: Status.SUPPLIER_QUEUE_STATUS_WAITING,
  1: Status.SUPPLIER_QUEUE_STATUS_AT_GATE,
  2: Status.SUPPLIER_QUEUE_STATUS_UNLOADING_FINISHED,
  3: Status.SUPPLIER_QUEUE_STATUS_DEPARTED,
};
